import * as React from "react";
import { connect } from "react-redux";

import CreateCaptureImage from "components/products/bar-home-page/CreateCaptureImage";
import ReimageTargetMachine from "components/products/bar-home-page/ReimageTargetMachine";
import SetupServerConfiguration from "components/products/bar-home-page/SetupServerConfiguration";
import SetupWinEraser from "components/products/bar-home-page/SetupWinEraser";
import ViewReport from "components/products/onboarding-view-report/ViewReport";
import { LicenseData } from "domain/licenses";
import {
    BarOnboardingSteps,
    checkIfMenuExpanded,
    checkIfStepIsClickable,
    getStepIndexForBar,
    isStepCompleted,
    OnboardingProductType,
} from "domain/onboardings";
import { OnboardingImage, SoftwarePackage, Versions } from "domain/softwarePackages";
import { Onboarding } from "services/onboardings/OnboardingsService";
import { StoreState } from "store";

const mapState = (state: StoreState) => ({
    theme: state.themeReducer.theme,
});

const connector = connect(mapState);

interface Props {
    lastCompletedStepIndex: number;
    licenses: Versions[];
    fetchedLicenses: LicenseData[];
    fetchedSoftwarePackages?: SoftwarePackage[];
    saveOnboardingStep: (onboarding: Onboarding) => void;
    stepInProgressIndex: number;
    saveStepInProgressIndex: (index: number) => void;
    fetchedOnboardingImages?: OnboardingImage[];
}

const BarSteps = (props: Props): JSX.Element => {
    const getStepIndex = (step: BarOnboardingSteps | undefined) => {
        return getStepIndexForBar(step);
    };

    return (
        <>
            <SetupWinEraser
                stepIndex={getStepIndex(BarOnboardingSteps.STEP_SETUP_WINERASER)}
                menuExpanded={checkIfMenuExpanded(
                    props.lastCompletedStepIndex,
                    getStepIndex(BarOnboardingSteps.STEP_SETUP_WINERASER),
                    false
                )}
                stepCompleted={isStepCompleted(
                    getStepIndex(BarOnboardingSteps.STEP_SETUP_WINERASER),
                    props.lastCompletedStepIndex
                )}
                stepActive={true}
                stepClickable={checkIfStepIsClickable(
                    getStepIndex(BarOnboardingSteps.STEP_SETUP_WINERASER),
                    props.lastCompletedStepIndex,
                    false
                )}
                saveOnboardingStep={props.saveOnboardingStep}
                stepInProgressIndex={props.stepInProgressIndex}
                saveStepInProgressIndex={props.saveStepInProgressIndex}
                fetchedOnboardingImages={props.fetchedOnboardingImages}
            />
            <SetupServerConfiguration
                stepIndex={getStepIndex(BarOnboardingSteps.STEP_SETUP_SERVER_CONFIGURATION)}
                menuExpanded={checkIfMenuExpanded(
                    props.lastCompletedStepIndex,
                    getStepIndex(BarOnboardingSteps.STEP_SETUP_SERVER_CONFIGURATION),
                    false
                )}
                stepCompleted={isStepCompleted(
                    getStepIndex(BarOnboardingSteps.STEP_SETUP_SERVER_CONFIGURATION),
                    props.lastCompletedStepIndex
                )}
                stepActive={false}
                stepClickable={checkIfStepIsClickable(
                    getStepIndex(BarOnboardingSteps.STEP_SETUP_SERVER_CONFIGURATION),
                    props.lastCompletedStepIndex,
                    false
                )}
                saveOnboardingStep={props.saveOnboardingStep}
                stepInProgressIndex={props.stepInProgressIndex}
                saveStepInProgressIndex={props.saveStepInProgressIndex}
                fetchedSoftwarePackages={props.fetchedSoftwarePackages}
                fetchedLicenses={props.fetchedLicenses}
            />
            <CreateCaptureImage
                stepIndex={getStepIndex(BarOnboardingSteps.STEP_CREATE_CAPTURE_IMAGE)}
                menuExpanded={checkIfMenuExpanded(
                    props.lastCompletedStepIndex,
                    getStepIndex(BarOnboardingSteps.STEP_CREATE_CAPTURE_IMAGE),
                    false
                )}
                stepCompleted={isStepCompleted(
                    getStepIndex(BarOnboardingSteps.STEP_CREATE_CAPTURE_IMAGE),
                    props.lastCompletedStepIndex
                )}
                stepActive={false}
                stepClickable={checkIfStepIsClickable(
                    getStepIndex(BarOnboardingSteps.STEP_CREATE_CAPTURE_IMAGE),
                    props.lastCompletedStepIndex,
                    false
                )}
                saveOnboardingStep={props.saveOnboardingStep}
                stepInProgressIndex={props.stepInProgressIndex}
                saveStepInProgressIndex={props.saveStepInProgressIndex}
                fetchedOnboardingImages={props.fetchedOnboardingImages}
                fetchedSoftwarePackages={props.fetchedSoftwarePackages}
            />
            <ReimageTargetMachine
                stepIndex={getStepIndex(BarOnboardingSteps.STEP_REIMAGE_TARGET_MACHINE)}
                menuExpanded={checkIfMenuExpanded(
                    props.lastCompletedStepIndex,
                    getStepIndex(BarOnboardingSteps.STEP_REIMAGE_TARGET_MACHINE),
                    false
                )}
                stepCompleted={isStepCompleted(
                    getStepIndex(BarOnboardingSteps.STEP_REIMAGE_TARGET_MACHINE),
                    props.lastCompletedStepIndex
                )}
                stepActive={false}
                stepClickable={checkIfStepIsClickable(
                    getStepIndex(BarOnboardingSteps.STEP_REIMAGE_TARGET_MACHINE),
                    props.lastCompletedStepIndex,
                    false
                )}
                saveOnboardingStep={props.saveOnboardingStep}
                stepInProgressIndex={props.stepInProgressIndex}
                saveStepInProgressIndex={props.saveStepInProgressIndex}
            />
            <ViewReport
                stepIndex={getStepIndex(BarOnboardingSteps.STEP_VIEW_REPORT)}
                menuExpanded={checkIfMenuExpanded(
                    props.lastCompletedStepIndex,
                    getStepIndex(BarOnboardingSteps.STEP_VIEW_REPORT),
                    false
                )}
                stepCompleted={isStepCompleted(
                    getStepIndex(BarOnboardingSteps.STEP_VIEW_REPORT),
                    props.lastCompletedStepIndex
                )}
                stepActive={false}
                stepClickable={checkIfStepIsClickable(
                    getStepIndex(BarOnboardingSteps.STEP_VIEW_REPORT),
                    props.lastCompletedStepIndex,
                    false
                )}
                saveOnboardingStep={props.saveOnboardingStep}
                product={OnboardingProductType.BAR}
                hasIbr={false}
            />
        </>
    );
};

export default connector(BarSteps);
